export default __webpack_public_path__ + "static/logo_with_background-829024f3ae32ddfd0c14f72068afc87e.jpg";